var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"login-form wmin-sm-400",attrs:{"action":"index.html"}},[_c('div',{staticClass:"card mb-0"},[_c('div',{staticClass:"min-vh-100 active card-body fade show tab-pane"},[_c('login-component',{attrs:{"sso":true,"redirect":this.$route.query.redirect}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50798955","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/central/authorization/IndexLoginSSO.vue
// module id = null
// module chunks = 